<div class="container">
  <div class="sidenav-second-level my-5">
    <div class="row gap-4 gap-lg-0">
      <div class="col-lg-4">
        <multisite-vertical-menu-type-one
        [navigationLinks]="navigationLinks"
        [pictureEditable]="false"
        [nameText]="user ? user.fname+' '+user.lname : '[No name]'"
        [picture]="user | userAvatar"
        >
        </multisite-vertical-menu-type-one>
      </div>
      <div class="col-lg-8">

        @if (user?.email_undeliverable) {
          <alert type="warning" *transloco="let t">
            <p class="fw-bold mb-1">{{ t('account.email_undeliverable') }}</p>
            <p>{{ t('account.email_undeliverable_explanation') }}</p>
            <a routerLink="email" class="btn btn-primary btn-sm">{{ t('authentication.change_email') }}</a>
          </alert>
        }

        <router-outlet></router-outlet>
        
      </div>
    </div>
  </div>
</div>